import { render } from "./voucher.vue?vue&type=template&id=6bb32a00&scoped=true"
import script from "./voucher.vue?vue&type=script&lang=js"
export * from "./voucher.vue?vue&type=script&lang=js"

import "./voucher.vue?vue&type=style&index=0&id=6bb32a00&scoped=true&lang=scss"
import "./voucher.vue?vue&type=style&index=1&id=6bb32a00&lang=css"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb32a00"]])

export default __exports__